import React, { useState, useEffect } from 'react';
import Card from '../../components/ui/Card';
import api from '../../services/api';

export default function PhotoReports() {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await api.get('/v1/display/photos?page=1&per_page=100');
        if (res?.data) setPhotos(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    }
    load();
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em' }}>Фото-отчёты</h1>
      {loading ? (
        <div style={{ textAlign: 'center', padding: 60 }}>
          <div style={{ width: 28, height: 28, borderRadius: '50%', border: '3px solid rgba(0,206,238,0.15)', borderTopColor: '#00CEEE', animation: 'spin 0.8s linear infinite', margin: '0 auto 10px' }} />
          <span style={{ color: '#94A3B8', fontSize: 13 }}>Загрузка...</span>
        </div>
      ) : photos.length > 0 ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
          {photos.map(p => (
            <Card key={p.id} style={{ transition: 'all 0.2s', cursor: 'pointer' }}>
              {p.photo_url && (
                <img src={p.photo_url} alt="" style={{
                  width: '100%', borderRadius: 10, marginBottom: 12,
                  aspectRatio: '16/10', objectFit: 'cover', background: '#F1F5F9',
                }} />
              )}
              <div style={{ fontWeight: 600, fontSize: 14, color: '#0F172A' }}>{p.product_name || '\u2014'}</div>
              <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 4 }}>{p.employee_name || '\u2014'} &bull; {p.store_name || '\u2014'}</div>
              <div style={{ fontSize: 12, color: '#CBD5E1', marginTop: 2 }}>{p.created_at ? new Date(p.created_at).toLocaleString('ru-RU') : '\u2014'}</div>
            </Card>
          ))}
        </div>
      ) : (
        <Card>
          <div style={{ textAlign: 'center', padding: 50, color: '#94A3B8', fontSize: 13 }}>Фото-отчёты ещё не загружены</div>
        </Card>
      )}
    </div>
  );
}
